import React, { useEffect, useState } from 'react';

import {
    Box,
    Button,
} from '@mui/material';

import ExpandedTextField from '../display/ExpandedTextField';
import ExpandedDropDown from '../dropdown/ExpandedDropDown';


export default function CreateConfigPopover(props){

    const {
        deliverables,
        setDeliverables,
        setCurrentDeliverable,
        submitConfig,
    } = props
    const [exportType, setExportType] = useState('')
    const [exportName, setExportName] = useState('')
    const [templateName, setTemplateName] = useState('')


    const createConfig = () => {
        if(templateName){
            submitConfig({
                'deliverable_name': exportName,
                'deliverable_type': exportType
            }, templateName)
        }
        else{
            let deliverable_content = {
                'deliverable_name': exportName,
                'deliverable_type': exportType
            }
            if (exportType == 'ALE'){
                deliverable_content['data'] = {}
                deliverable_content['args'] = {}
            } else if (exportType == 'PDF' || exportType == 'ARCHIVE'){
                deliverable_content['data'] = {}
                deliverable_content['args'] = {}
                deliverable_content['context'] = {}
                deliverable_content['table'] = {}
            }

            submitConfig(deliverable_content)

            setDeliverables((prev) => {
                return [...prev, {
                    name: exportName,
                    type: exportType
                }]
            })
            setCurrentDeliverable({
                name: exportName,
                type: exportType
            })
        }
    }

    const createButtonIsDisabled = () => {
        if(exportName && exportType){
            // Check if template is selected
            if(templateName){
                return false
            }
            else if(deliverables
                .filter(item => item.type === exportType)
                .map(item => item.name)
                .includes(exportName)
            ){
                return true
            }
            return false
        }
        return true
    }


    return (
        <Box
            width={'260px'}
        >
            <Box
                height={'200px'}
                overflow={'auto'}
            >
                <ExpandedTextField
                    label={'Deliverable Name'}
                    value={exportName}
                    onChange={(e) => setExportName(e.target.value)}
                />
                <ExpandedDropDown
                    label={'Export Type'}
                    value={exportType}
                    options={[
                        {'name': '', 'value': ''},
                        ...[
                            ...new Set(
                                deliverables.map(item => item.type))]
                            .map(item => {
                                return {'name': item, 'type': item}
                            })
                    ]}
                    onChange={(e) => setExportType(e.target.value)}
                    fullWidth

                />
                {exportName && exportType && (
                    <ExpandedDropDown
                        label={'Copy config from'}
                        value={templateName}
                        options={[
                            {'name': '', 'value': ''},
                            ...deliverables.filter(item => item.type === exportType)
                            .map(item => ({'name': item.name, 'value': item.name}))
                        ]}
                        onChange={(e) => setTemplateName(e.target.value)}
                        fullWidth
                    />
                )}
            </Box>     
            <Box
                display={'flex'}
                justifyContent={'space-between'}
            >
                <Button
                    sx={{ color: 'red' }}
                >
                    Cancel
                </Button>
                <Button
                    sx={{ color: 'white' }}
                    onClick={createConfig}
                    disabled={createButtonIsDisabled()}
                >
                    Create
                </Button>
            </Box>
        </Box>
    )
}